import posthog from 'posthog-js';
import ENV from '../../environment';

export function initPostHog() {
  if (!ENV.POSTHOG_KEY) return;
  posthog.init(ENV.POSTHOG_KEY, {
    api_host: ENV.POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: 'history_change',
    persistence: 'localStorage+cookie',
    // Session replay off for everyone; opt in via posthog.startSessionRecording().
    disable_session_recording: true,
  });
}
